import { Outlet, useLocation } from "react-router";
import { useEffect } from "react";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";
import { useAuthBootstrap } from "../hooks/useAuthBootstrap";
import { safeSetItem } from "../utils/safeStorage";

export function Layout() {
  const { pathname } = useLocation();
  useAuthBootstrap();

  // Capture referral param on first load
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      safeSetItem("referrer", ref);
    }
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex w-full min-h-screen flex-col">
      <Nav />
      <main className="min-w-0 flex flex-1 flex-col">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
}
